function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M8 7.94c1.834 0 3.362-1.627 3.362-3.71C11.362 2.196 9.826.62 8 .62S4.622 2.22 4.63 4.246C4.63 6.313 6.166 7.94 8 7.94m-5.495 7.745h10.982c.963 0 1.544-.465 1.544-1.229 0-2.133-2.731-5.055-7.04-5.055-4.3 0-7.03 2.922-7.03 5.056 0 .763.581 1.228 1.544 1.228"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-booking-passenger.svg";
export { SvgComponent as ReactComponent };